import { orderBy as _orderBy } from 'lodash-es';
import { IColumn } from '../../model/IColumn';
import { IGetMeasure } from '../../apis/apiSlice';
import { ISelectableValue } from '../../model/measure';

export const getPadding = (col: IColumn) => (col.disablePadding ? 'none' : 'normal');

export interface IPaginatedRows {
  sortedRows: Array<IGetMeasure>;
  totalCount: number;
}

export const getSortedPageRows = (
  data: Array<IGetMeasure>,
  orderBy: string | ((item: any) => string | number),
  orderDir: 'asc' | 'desc',
  page?: number,
  rowsPerPage?: number,
  showAll?: boolean,
  cycleOption?: string,
  measureIdFilter?: string,
  ownerCompanyNameFilter?: ISelectableValue,
  actionField?: ISelectableValue,
  createdBy?: ISelectableValue,
  updatedBy?: ISelectableValue
) => {
  const showAllCycles = !cycleOption || cycleOption === "all";
  const searchedMeasures = showAll ? data : data.filter((measure: IGetMeasure) => measure.ownedByUser)
  const measuresFilteredByCycle = showAllCycles ? searchedMeasures : searchedMeasures.filter((measure: IGetMeasure) => measure.createdInCycle === parseInt(cycleOption))
  const measuresFilteredById = measureIdFilter ? measuresFilteredByCycle.filter((measure: IGetMeasure) =>  measure.measureId === parseInt(measureIdFilter)) :  measuresFilteredByCycle 
  const measuresFilteredByOwnerCompanyName = ownerCompanyNameFilter ? measuresFilteredById.filter((measure: IGetMeasure) =>  measure.projectDeveloper === ownerCompanyNameFilter.id) : measuresFilteredById
  const measuresFilteredByActionField = actionField ? measuresFilteredByOwnerCompanyName.filter((measure: IGetMeasure) =>  measure.actionField !== undefined && measure.actionField === actionField.id) : measuresFilteredByOwnerCompanyName
  const measuresFilteredByCreatedby = createdBy ? measuresFilteredByActionField.filter((measure: IGetMeasure) =>  measure.createdBy === createdBy.id) : measuresFilteredByActionField
  const measuresFilteredByUpdatedby = updatedBy ? measuresFilteredByCreatedby.filter((measure: IGetMeasure) =>  measure.updatedBy === updatedBy.id) : measuresFilteredByCreatedby
  const fixEmptyUpdatedAt = measuresFilteredByUpdatedby.map((m: IGetMeasure) => {
    return !m.updatedAt ? {...m, updatedAt: ""} : m
  })
  const sortedData = _orderBy(fixEmptyUpdatedAt, orderBy, orderDir);
  if (rowsPerPage != undefined && page != undefined){
    const result = getPageRows(page, rowsPerPage, sortedData);
    return {sortedRows: result, totalCount: sortedData.length};
  }
  return {sortedRows: sortedData, totalCount: sortedData.length};
};

const getPageRows = (page: number, rowsPerPage: number, data: Array<IGetMeasure>) =>
  data.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

export const getRender = (col: IColumn) => col.render || ((value) => value);
